import type {CSSSection} from '@cohort/wallet/lib/css';
import {getPageAndSectionFromCssSection} from '@cohort/wallet/lib/css';
import {useState} from 'react';

export default function useSectionVisibility(sectionName: CSSSection): boolean {
  const [isHidden] = useState(() => {
    const [page, section] = getPageAndSectionFromCssSection(sectionName);
    const visibility = getComputedStyle(document.documentElement).getPropertyValue(
      `--xps-section-${page}-${section}-visibility`
    );

    return visibility === 'hidden';
  });

  return !isHidden;
}
